var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
var l10n = require("diy/util/l10n");

(function() {
    var EMPNotification = NotificationBase.extend({
        softDeletion: true,
        severityDefault: 4,
        stickyDefault: 0,
        categoryDefault: 2,
        iconCls: 'ui-icon-star',
        vCardEditor: null,
        contentEl: null,
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            if (this.contentEl === null) {
                this.contentEl = $(
                    '<div class="title">' + l10n.getString("notifications.emp.title") + '</div>' +
                    '<div class="description">' + l10n.getString("notifications.emp.content") + '</div>'
                );
            }

            return this.contentEl;
        },

        globalAction: function() {
            if (this.vCardEditor === null) {
                throw new Exception('EMP notification global action unreachable');
            }

            this.vCardEditor.open({
                element: this.contentEl,
                openCallback: function() {}
            });
        },

        setVCardEditor: function(vCardEditor) {
            this.vCardEditor = vCardEditor;
        },

        getName: function() {
            return 'EMPNotification';
        }
    });

    module.exports = EMPNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/EMPNotification.js
 ** module id = 659
 ** module chunks = 0
 **/